import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchWarehouseLocationDetail(id) {
  const { data: raw } = await request.get(`/system/warehouse-location/${id}`);
  return parseVer4DetailResponse(raw);
}
